import { cx } from '@orn/shared-web/utils/cx';
import { NavLink } from 'react-router-dom';

import { IS_PROD } from '../../env';
import { PATHS } from '../../paths';

interface IAssistantNavItem {
  label: string;
  to: string;
}

const ITEMS: IAssistantNavItem[] = [
  { label: 'Feedback', to: PATHS.ASSISTANT_FEEDBACK },
  { label: 'Memory', to: PATHS.ASSISTANT_MEMORY },
  { label: 'Threads', to: PATHS.ASSISTANT_THREADS },
  // Staging-only: the benchmark tool dispatches expensive on-demand eval runs.
  ...(IS_PROD ? [] : [{ label: 'Benchmarks', to: PATHS.ASSISTANT_BENCHMARKS }]),
];

/**
 * Sub-tab strip for the Assistant tool. New sub-tabs are added by
 * appending to `ITEMS`. The strip is intentionally a thin local
 * component — there is only ever one consumer, no need to promote
 * into a shared primitive.
 */
const AssistantNav = () => (
  <nav className="border-border-primary flex gap-1 border-b text-xs uppercase tracking-wider">
    {ITEMS.map((item) => (
      <NavLink
        key={item.to}
        to={item.to}
        className={({ isActive }) =>
          cx(
            '-mb-px border-b-2 px-3 py-2 font-medium transition-colors',
            isActive
              ? 'text-fg-brand-primary border-fg-brand-primary'
              : 'text-fg-secondary hover:text-fg-primary border-transparent'
          )
        }
      >
        {item.label}
      </NavLink>
    ))}
  </nav>
);

export default AssistantNav;
